// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"94192a49","301":"2f35714e","450":"b145bc26","459":"0e1d3321","651":"63ee045d"}[chunkId] + ".chunk.js";
};